// extracted by mini-css-extract-plugin
export default {"contents":"dE-z","sectionHeading":"eE-z"};